import {useAppDispatch, useAppSelector} from "../../stores/store.ts";
import EpgDetails from "../epg/EpgDetailsModal/EpgDetails.tsx";
import {IChannel} from "../../interfaces/IChannel.ts";
import {modalsStateActions} from "../popups/modalsStateSlice.ts";
import {useContext, useEffect} from "react";
import {XCircleIcon} from "@heroicons/react/24/outline";
import {epgDetailsActions} from "../epg/EpgDetailsModal/epgDetailsSlice.ts";
import {IPlayerChannel} from "../../interfaces/player/IPlayerUIState.ts";
import {AppMainStateContext} from "../../contexts/AppMainStateContext.tsx";

interface IProps {
    channels: IChannel[]
}

const EpgPageXDetailsModal = ({channels}: IProps) => {
    const {closeModal} = useContext(AppMainStateContext);
    const isOpen = useAppSelector(store => store.modalsState.isEpgDetailsOpen);
    const dispatch = useAppDispatch();
    const handleCloseClick = () => {
        dispatch(modalsStateActions.setIsEpgDetailsOpen(false));
        closeModal();
    }
    useEffect(() => {
        const body = document.querySelector("body") as HTMLElement;
        if (isOpen)
            body.classList.add("overflow-hidden");
        else {
            body.classList.remove("overflow-hidden");
            dispatch(epgDetailsActions.setSelectedView("MAIN_VIEW"));
        }
    }, [isOpen]);

    useEffect(() => {
        return () => {
            const body = document.querySelector("body") as HTMLElement;
            body.classList.remove("overflow-hidden");
            dispatch(epgDetailsActions.setSelectedView("MAIN_VIEW"));
            dispatch(modalsStateActions.setIsEpgDetailsOpen(false));
        }
    }, [])

    return (
        <div
            className={`${isOpen ? "fixed" : "hidden"}  top-0 left-0 w-screen h-screen z-[60] animate-opacityEaseIn`}>
            <div className={"relative w-full h-full flex justify-center items-center"}>
                <div
                    className={"bg-neutral-900/50 absolute top-0 left-0 w-full h-full z-0"}
                    onClick={handleCloseClick}
                />
                <div className={"relative max-w-2xl w-full z-10"}>
                    {/*<button*/}
                    {/*    className={"absolute right-1 -top-11"}*/}
                    {/*    onClick={() => handleCloseClick()}*/}
                    {/*>*/}
                    {/*    <XCircleIcon*/}
                    {/*        className={"w-9 h-9 text-neutral-200 hover:text-white transition-colors stroke-[1.5]"}/>*/}
                    {/*</button>*/}
                    {isOpen &&
                        <EpgDetails channels={channels.map(x => ({
                            ch_id: x.ch_id,
                            cmd: x.cmd,
                            enabled: x.enabled,
                            epgList: x.epgList,
                            firstEpgId: 0,
                            lastEpgId: 0,
                            logo: x.logo,
                            name: x.name
                        } as IPlayerChannel))}/>}
                </div>
            </div>
        </div>
    );
};

export default EpgPageXDetailsModal;